export const state = {
  // product: undefined,
  // products: []
  banniere: {},
  bannieres: [],
  pagination:''
}
